import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IDotXetChungChiPhamViSinhVienInsertRequest } from "../../../model/request/xet-chung-chi/IDotXetChungChiPhamViSinhVienInsertRequest";
import { IDotXetChungChiPhamViSinhVienSelectRequest } from "../../../model/request/xet-chung-chi/IDotXetChungChiPhamViSinhVienSelectRequest";
import { IDotXetChungChiPhamViSinhVienViewModel } from "../../../model/response/xet-chung-chi/IDotXetChungChiPhamViSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetChungChiPhamViSinhVienActionsObj = {
    LOAD_BY_DOT_XET_START: {} as IDotXetChungChiPhamViSinhVienSelectRequest,
    LOAD_BY_DOT_XET_SUCCESS: [] as IDotXetChungChiPhamViSinhVienViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    INSERTS_START: {} as IDotXetChungChiPhamViSinhVienInsertRequest,
    INSERTS_SUCCESS: undefined,
    INSERTS_ERROR: "",

    DELETES_START: {} as IIdsRequest,
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP: {} as boolean,
}

export const eDotXetChungChiPhamViSinhVienActionIds = generateActionTypeIds(eDotXetChungChiPhamViSinhVienActionsObj, "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN");
export type IDotXetChungChiPhamViSinhVienActionTypes = IGenericActionType<typeof eDotXetChungChiPhamViSinhVienActionsObj, "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN">;